{
  "min": -923,
  "max": 679,
  "R": [0, 0, 0, 0, 0, 255, 255, 255],
  "G": [154, 154, 154, 154, 0, 0, 254, 255],
  "B": [179, 179, 179, 179, 0, 0, 0, 255],
  "A": [0, 3, 8, 0, 0, 10, 15, 20],
  "I": [0, 30, 62, 88, 170, 200, 232, 255]
}
